import React from 'react';
import { BeforeAfterAndBonuses, GuaranteeAndCost, PainAndTransformation, ProductOverview, SocialAndFAQ, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2mm2j470bqezq">
      <MetaPixel data-id="element-1" data-mp="31brzh9gzmpkl" />
      <TopBar data-id="element-2" data-mp="31c9ygdv1bhw7" />
      <main data-id="element-3" data-mp="31ctflscv2296">
        <Hero data-id="element-4" data-mp="2wk09p15nonvi" />
        <Testimonials data-id="element-5" data-mp="2wka02pum4x1q" />
        <Pricing id="oferta" data-id="element-6" data-mp="2wiyx2s8zrtbo" />
        <PainAndTransformation data-id="element-7" data-mp="2wip7v6vrtq71" />
        <ProductOverview data-id="element-8" data-mp="28ufmg62gz4gf" />
        <BeforeAfterAndBonuses data-id="element-9" data-mp="28tme50nv46w6" />
        <Pricing data-id="element-10" data-mp="28sl32w6ujkeg" />
        <SocialAndFAQ data-id="element-11" data-mp="28s2xva27hvue" />
        <GuaranteeAndCost data-id="element-12" data-mp="23vkuoemiy5k6" />
      </main>
      <Footer data-id="element-13" data-mp="23ujlkfp2jt53" />
      <FloatingElements data-id="element-14" data-mp="23v2rsz5cwt3a" />
      <noscript data-id="element-15" data-mp="3ijxpcqos80jw">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-16" data-mp="3ik7jmqgv0tve" />
      </noscript>
    </div>;
}